// extracted by mini-css-extract-plugin
export default {"wrapper":"_5314187f"};